import { z } from 'zod';
import { MemberInput } from '../referralFormSchema';

export enum FieldEnum {
  'firstName' = 'firstName',
  'lastName' = 'lastName',
  'email' = 'email',
  'phoneNumber' = 'phoneNumber',
}

export const memberInputFieldsConfig = {
  [FieldEnum.firstName]: {
    name: FieldEnum.firstName,
    label: 'Customer first name',
    required: true,
    type: 'text',
    helperText: 'Max 100 characters',
  },
  [FieldEnum.lastName]: {
    name: FieldEnum.lastName,
    label: 'Customer last name',
    required: true,
    type: 'text',
    helperText: 'Max 100 characters',
  },
  [FieldEnum.email]: {
    name: FieldEnum.email,
    label: 'Customer email',
    required: true,
    type: 'email',
    helperText: null,
  },
  [FieldEnum.phoneNumber]: {
    name: FieldEnum.phoneNumber,
    label: 'Customer phone',
    required: true,
    type: 'text',
    helperText: 'Must be entered as 01-111-111-1111. Country code is optional.',
  },
} as const;

export type MemberInputType = z.input<typeof MemberInput>;
